import styled from 'styled-components';

import { getScoreBands } from '@components/status-cell/helpers';

import { ScoreBandColors, SCORE_BAND_TYPES } from '@components/view-key/view-key-colors';

const { HOVER, DEFAULT } = SCORE_BAND_TYPES;

export const getScoreBandColor = (range, type) =>
  getScoreBands({
    currentlyAssigned: type === DEFAULT ? '#CBE8BC' : '#DAE7D3',
    completed1to20: ScoreBandColors.completed1to20[type],
    completed21to40: ScoreBandColors.completed21to40[type],
    completed41to60: ScoreBandColors.completed41to60[type],
    completed61to80: ScoreBandColors.completed61to80[type],
    completed81to100: ScoreBandColors.completed81to100[type],
    range
  });

export const ToolTipWrapper = styled.div`
  display: none;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 20px;
  left: -3px;
  color: white;
  font-size: 10px;
  height: 23px;

  &:before {
    display: none;
    bottom: 95%;
    left: 10px;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border: 5px solid transparent;
    border-bottom-color: #3b4e5e;
    margin-left: -5px;
  }
`;

export const AssignInfo = styled.div(props => {
  const { hasAccuracyResult } = props;

  return `
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding: 0 5px;
    white-space: nowrap;
    height: 100%;
    background-color: #3b4e5e;
    color: white;
    border-radius: ${hasAccuracyResult ? '5px 0 0 5px' : '5px'};
  `;
});

export const AccuracyInfo = styled.div(props => {
  const { resultAccuracy, hasAccuracyResult } = props;

  const bgColor = hasAccuracyResult ? getScoreBandColor(resultAccuracy, DEFAULT) : '#3b4e5e';

  return `
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${hasAccuracyResult ? '30px' : '0px'};
    height: 100%;
    background-color: ${bgColor};
    border-radius: 0 5px 5px 0;
    color: white;
  `;
});

export const Root = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover ${ToolTipWrapper} {
    display: flex;

    &:before {
      display: flex;
    }
  }
`;

export const Circle = styled.div(props => {
  const { isFocusedResult, resultAccuracy } = props;

  const circleSize = isFocusedResult ? 10 : 12;

  const scoreBandColorDefault = getScoreBandColor(resultAccuracy, DEFAULT);
  const scoreBandColorHover = getScoreBandColor(resultAccuracy, HOVER);

  return `
    margin-right: ${isFocusedResult ? '1px' : '0px'};
    width: ${circleSize}px;
    height: ${circleSize}px;
    border-radius: 50%;
    background-color: ${isFocusedResult ? scoreBandColorDefault : scoreBandColorHover};

    ${
  isFocusedResult
    ? `
          border: 2px solid #fff;
          box-shadow: 0 0 0 1px #3b4e5e;
        `
    : ''
}

    &:hover {
      background-color: ${scoreBandColorDefault};
      ${isFocusedResult ? `box-shadow: 0 0 0 1px ${scoreBandColorDefault}` : ''}
    }
  `;
});

export const ConnectBlock = styled.div`
  background-color: #cfcfcf;
  width: 5.5px;
  height: 2.5px;
`;
